import { track } from "instrumentation/tracking/track";

export const trackCompleteJourneyTask = (fields) => track("track_complete_journey_task", fields);

export const trackOnboardingClickSideMenu = (fields) => track("journey_task_click_side_menu", fields);

export const trackViewJourneyTask = (fields) => track("view_journey_task", fields);

export const trackOnboardingError = (fields) => track("onboarding_error", fields);
